import { ColumnDef } from '@tanstack/react-table'
import { AppTable, AppTableProps, AppTypography } from 'components'
import { FeedbackTypes } from 'globals/constants'
import { getMDYFormattedDate } from 'globals/functions'
import { FC } from 'react'
import { FeedbackViewModel } from 'sdk'

interface Props extends AppTableProps<FeedbackViewModel> {}
export const ReviewsTable: FC<Props> = ({ ...props }) => {
  const columns: ColumnDef<FeedbackViewModel>[] = [
    {
      header: 'Date',
      cell: ({ row }) => <AppTypography>{getMDYFormattedDate(new Date(row.original.Created))}</AppTypography>,
    },
    {
      header: 'Email',
      accessorKey: 'Email',
    },
    // {
    //   header: 'Type',
    //   accessorKey: 'Type',
    //   cell: ({ row }) => <AppTypography>{FeedbackTypes[row.original.Type]}</AppTypography>,
    // },
    {
      header: 'Rating',
      cell: ({ row }) => (
        <AppTypography>{row.original.Type === 0 ? row.original.Value + ' Stars' : row.original.Value}</AppTypography>
      ),
    },
    {
      header: 'Comments',
      accessorKey: 'Comment',
    },
  ]
  return (
    <>
      <AppTable columns={columns} {...props} />
    </>
  )
}
